import React from 'react';
import Loadable from 'react-loadable';
import Spinner from '@atlaskit/spinner/spinner';
export const AttachmentAsync = Loadable({
  loader: () => import( /* webpackChunkName: "@atlaskit-internal_proforma-attachment-field" */'./Attachment').then(mod => mod.Attachment),
  loading: () => /*#__PURE__*/React.createElement(Spinner, null)
});